import React from 'react';
import ReactEcharts from 'echarts-for-react';
import { observer, inject } from 'mobx-react';
import { Table, DatePicker, Row, Col } from 'antd';
import { getBrokenLineOption } from '../../const/EchartsConst';
import styles from './DeviceMonitor.less';
import { DeviceInfoTab2Table } from '../../const/TableConst';
import moment from 'moment';

const { RangePicker } = DatePicker;

function disabledDate(current) {
  return (
    current.isBefore(moment('2017-01-01').startOf('day')) ||
    current.isAfter(moment().endOf('day'))
  );
}
@inject('deviceInfoMonitorStore', 'deviceInfoStore')
@observer
class Tab2 extends React.Component {
  state = {
    start: moment(),
    end: moment()
  };

  componentDidMount() {
    const { deviceInfoStore } = this.props;
    const { start, end } = this.state;
    const deviceId = deviceInfoStore.deviceId;
    this.loadData(deviceId, start, end);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.deviceInfoStore.deviceId) {
      const deviceId = nextProps.deviceInfoStore.deviceId;
      const { start, end } = this.state;
      this.loadData(deviceId, start, end);
    }
  }

  loadData(deviceId, start, end) {
    const { deviceInfoMonitorStore } = this.props;
    deviceInfoMonitorStore.loadCpu(deviceId, start, end);
    deviceInfoMonitorStore.loadMemory(deviceId, start, end);
    deviceInfoMonitorStore.loadTraffic(deviceId, start, end);
    deviceInfoMonitorStore.loadNet(deviceId, start, end);
    deviceInfoMonitorStore.loadProgress(deviceId, start, end);
  }

  onDateChange = dates => {
    const [start, end] = dates;
    this.setState({
      start,
      end
    });
    const { deviceInfoStore } = this.props;
    const deviceId = deviceInfoStore.deviceId;
    this.loadData(deviceId, start, end);
  };

  render() {
    const {
      deviceCpu,
      deviceMemory,
      deviceTraffic,
      deviceNet,
      deviceProgress
    } = this.props.deviceInfoMonitorStore;
    const { start, end } = this.state;
    return (
      <div className={styles.deviceInfoTab2}>
        <Row
          style={{
            alignItems: 'center',
            display: 'flex',
            paddingLeft: 30,
            marginBottom: 16,
            marginTop: 8
          }}
        >
          <Col span={1}>日期选择:</Col>
          <Col span={6}>
            <RangePicker
              disabledDate={disabledDate}
              value={[start, end]}
              onChange={this.onDateChange}
            />
          </Col>
        </Row>
        <div className={styles.echartContainer}>
          <div className={styles.echart}>
            <ReactEcharts
              option={getBrokenLineOption(deviceCpu)}
              notMerge={true}
              lazyUpdate={true}
              style={{ height: '190px', width: '100%' }}
            />
          </div>
          <div className={styles.echart}>
            <ReactEcharts
              option={getBrokenLineOption(deviceMemory)}
              notMerge={true}
              lazyUpdate={true}
              style={{ height: '190px', width: '100%' }}
            />
          </div>
          <div className={styles.echart}>
            <ReactEcharts
              option={getBrokenLineOption(deviceNet)}
              notMerge={true}
              lazyUpdate={true}
              style={{ height: '190px', width: '100%' }}
            />
          </div>
          <div className={styles.echart}>
            <ReactEcharts
              option={getBrokenLineOption(deviceTraffic)}
              notMerge={true}
              lazyUpdate={true}
              style={{ height: '190px', width: '100%' }}
            />
          </div>
        </div>
        <div>
          <Table
            columns={DeviceInfoTab2Table}
            dataSource={[...deviceProgress] || []}
          />
        </div>
      </div>
    );
  }
}
export default Tab2;



// WEBPACK FOOTER //
// ./src/components/DeviceInfo/DeviceMonitor.js